function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 14,
  height: 12
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.86946 0L8.3288 4.49139H13.0513L9.23072 7.26722L10.6901 11.7586L6.86946 8.98278L3.04886 11.7586L4.5082 7.26722L0.687594 4.49139H5.41012L6.86946 0Z",
  fill: "#FCCF42"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 6.86946,
  width: 6.5,
  height: 13,
  fill: "#CCCCCC"
}));

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 14,
  height: 12
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.86946 0L8.3288 4.49139H13.0513L9.23072 7.26722L10.6901 11.7586L6.86946 8.98278L3.04886 11.7586L4.5082 7.26722L0.687594 4.49139H5.41012L6.86946 0Z",
  fill: "#FCCF42"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.369461,
  width: 6.5,
  height: 13,
  fill: "#FCCF42"
}));

var SvgHalfStar = function SvgHalfStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHalfStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/half-star.ecea1122.svg";
export { ForwardRef as ReactComponent };